const SIZES = ['bytes', 'KB', 'MB', 'GB', 'TB'];

export function formatSize(size: string, decimals = 2) {
  const bytes = parseInt(size, 10);
  if (!+bytes) return `0 ${SIZES[0]}`;

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${SIZES[i]}`;
}
